import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';

const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  },
  de: {
    translation: deTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    supportedLngs: ['en', 'fr', 'de'],
    nonExplicitSupportedLngs: true, // map fr-FR -> fr, en-GB -> en, etc.

    detection: {
      // Persist user selection first; fall back to browser language on first visit
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    }
  });

// Keep the <html lang> in sync and ensure persistence works reliably
if (typeof document !== 'undefined') {
  document.documentElement.lang = (i18n.language || 'en').split('-')[0];
}

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = (lng || 'en').split('-')[0];
  }
  try {
    localStorage.setItem('i18nextLng', lng);
  } catch (e) {}
});

export default i18n;
